import { MutableRefObject } from 'react';
import { fabric } from '../../../../vendor/fabric';
import { getCanvasSize } from './getCanvasSize';

export const buildCanvas = async ({
  blob,
  imageRef,
  canvasRef,
  color,
  containerWidth,
  containerHeight,
  setSelectedObject
}: {
  blob: string;
  imageRef: MutableRefObject<HTMLCanvasElement | null>;
  canvasRef: MutableRefObject<fabric.Canvas | null>;
  color: string;
  containerWidth?: number;
  containerHeight?: number;
  setSelectedObject: (object: fabric.Object[] | undefined) => void;
}) => {
  if (canvasRef?.current) {
    // if the user comes back to edit annotations
    canvasRef.current.renderAll();
    return;
  }

  const dimensions = await getCanvasSize({
    blob,
    containerWidth,
    containerHeight
  });

  const canvas = imageRef.current;

  const fabricCanvas = new fabric.Canvas(canvas, {
    isDrawingMode: true,
    imageSmoothingEnabled: false
  });

  fabricCanvas.setDimensions({
    width: dimensions.width,
    height: dimensions.height
  });

  canvasRef.current = fabricCanvas;

  fabricCanvas.setBackgroundImage(
    blob,
    fabricCanvas.renderAll.bind(fabricCanvas),
    {
      scaleX: dimensions.scale,
      scaleY: dimensions.scale
    }
  );

  fabricCanvas.on('object:scaling', e => {
    var o = e.target;
    if (!o.strokeWidthUnscaled && o.strokeWidth) {
      o.strokeWidthUnscaled = o.strokeWidth;
    }
    if (o.strokeWidthUnscaled) {
      o.strokeWidth = o.strokeWidthUnscaled / o.scaleX;
    }
  });

  fabricCanvas.freeDrawingBrush.color = color;
  fabricCanvas.freeDrawingBrush.width = 5;
  fabricCanvas.on('selection:created', e => setSelectedObject(e.selected));
  fabricCanvas.on('selection:updated', e => setSelectedObject(e.selected));
  fabricCanvas.on('before:selection:cleared', _e =>
    setSelectedObject(undefined)
  );
};
